import { render, staticRenderFns } from "./UICloseButton.vue?vue&type=template&id=06e698a2&scoped=true"
import script from "./UICloseButton.vue?vue&type=script&lang=js"
export * from "./UICloseButton.vue?vue&type=script&lang=js"
import style0 from "./UICloseButton.vue?vue&type=style&index=0&id=06e698a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e698a2",
  null
  
)

export default component.exports